import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Capacitor } from '@capacitor/core'
import { preloadInitialLocale } from './i18n/translationsCore'

// Add class to body to identify native vs web platform
if (Capacitor.isNativePlatform()) {
  document.body.classList.add('native-platform')
} else {
  document.body.classList.add('web-platform')
}

void preloadInitialLocale().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})

